import { ApiResponse } from '@restaurant/types';
import httpClient from '~/http';
import { PriceRoundingConfigData, PriceRoundingData } from './types';

const API_URL = '/api/v1/roundings/configs';

export const fetchPriceRoundingConfig = () => {
  return httpClient.get<ApiResponse<PriceRoundingConfigData>>(API_URL);
};

export const updatePriceRoundingConfig = (body: PriceRoundingConfigData) => {
  return httpClient.post(API_URL, body);
};

export const fetchPriceRounding = (price: number) => {
  return httpClient.post<ApiResponse<PriceRoundingData>>('/api/v1/roundings', {
    totalPrice: price,
  });
};
